import React from "react";
import Text from "Components/shared/text";
import styles from "./container.module.css";
import { TransactionHeader } from "./TransactionHeader";
import { TransactionBody } from "./TransactionBody";

export const TransferTransaction = ({handleClick}) => {
  return (
    <Text tag="div" className={styles.todoContainer}>
      {/* <TransactionHeader handleClick={handleClick}/> */}
      <TransactionBody />
    </Text>
  );
};

